import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    cannedResponses: [],
    createDetailsTable: false,
    cannedResponsesIntegration: null
  },
  getters: {
    getCannedResponses(state) {
      return state.cannedResponses;
    },
    getCannedResponsesIntegration(state) {
      return state.cannedResponsesIntegration;
    }
  },
  mutations: {
    setCannedResponses(state, newCannedResponses) {
      state.cannedResponses = newCannedResponses;
    },
    setCreateDetailsTable(state, newCreateDetailsTable) {
      state.createDetailsTable = newCreateDetailsTable;
    },
    setCannedResponsesIntegration(state, newCannedResponses) {
      state.cannedResponsesIntegration = newCannedResponses;
    }
  },
  actions: {
    async getCannedResponses({ commit }, mode_name) {
      try {
        let params = {};
        params.mode = mode_name;
        const response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/canned/mode`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status == 200) {
          commit("setCannedResponses", response.data.data);
        }
        return response.data.data;
      } catch (err) {
        if (err.response.status == 403) return tokenExpired();
        else if (err.response.status === 400) {
          commit("setCannedResponses", []);
          return err.response.status;
        } else if (err.response.status != 200) return errorMessage();
        return err.response;
      }
    },

    async getCannedResponsesIntegration({ commit }, mode_name) {
      try {
        let params = {};
        params.mode = mode_name;
        const response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/canned/mode`,
          {
            params: params,
            ...api.getToken()
          }
        );

        if (response.status == 200) {
          commit("setCannedResponsesIntegration", response.data.data);
        }
        return response.data;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    // Cambios con el admin panel
    async getCannedResponseById(__, info) {
      try {
        let params = {};
        params.mode = info.mode_name;
        const response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/canned/${info.canned_id}/mode`,
          {
            params: params,
            ...api.getToken()
          }
        );
        return response;
      } catch (err) {
        if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
